/// <reference types="./attributes.d.mts" />
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $component from "../../../../lustre/lustre/component.mjs";
import { Ok, Error } from "../../../gleam.mjs";

export function string(attribute, msg) {
  return $component.on_attribute_change(
    attribute,
    (value) => { return new Ok(msg(value)); },
  );
}

export function nullable(attribute, msg) {
  return $component.on_attribute_change(
    attribute,
    (value) => {
      let $ = $string.lowercase(value);
      if ($ === "") {
        return new Ok(msg(new $option.None()));
      } else if ($ === "null") {
        return new Ok(msg(new $option.None()));
      } else {
        return new Ok(msg(new $option.Some(value)));
      }
    },
  );
}

export function bool(attribute, msg) {
  return $component.on_attribute_change(
    attribute,
    (value) => {
      let $ = $string.lowercase(value);
      if ($ === "true") {
        return new Ok(msg(true));
      } else if ($ === "false") {
        return new Ok(msg(false));
      } else {
        return new Error(undefined);
      }
    },
  );
}

export function bool_to_string(value) {
  let _pipe = $bool.to_string(value);
  return $string.lowercase(_pipe);
}
